<template>
  <div class="bubble-greetings">
    <span class="close-button" @click.prevent="closeGreetings">
      <CloseSVG />
    </span>
    <h1>{{ business.title }}</h1>
    <p>{{ business.message }}</p>
    <a
      class="order-button"
      href="#"
      @click.prevent="showOrdering"
      :style="buttonCustom"
    >
      {{ $t("label.order_now") }}
    </a>
    <span class="powered-by">
      We're <PoweredIcon /> by
      <a href="https://www.chatfood.io" target="_blank">ChatFood</a>
    </span>
  </div>
</template>

<script>
import PoweredIcon from "@/assets/svgs/lightning.svg";
import CloseSVG from "@/assets/svgs/close.svg";
import { mapActions, mapGetters } from "vuex";
import PostMessages from "@/services/PostMessages";

export default {
  components: {
    PoweredIcon,
    CloseSVG
  },
  computed: {
    ...mapGetters({
      business: "getBusiness",
      themeColor: "getThemeColor",
      textColor: "getTextColor"
    }),
    buttonCustom() {
      let styles = "";

      if (this.themeColor) {
        styles += `background-color: ${this.themeColor};`;
      }

      if (this.textColor) {
        styles += `color: ${this.textColor};`;
      }

      return styles;
    }
  },
  watch: {
    business: {
      handler() {
        if (typeof this.$el === "undefined") return;

        this.$nextTick(() => {
          const height = this.getElHeight();
          const messages = new PostMessages("setGreetingsHeight", { height });
          messages.send();
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setBusiness: "setBusiness"
    }),
    getElHeight() {
      const height = document.defaultView
        .getComputedStyle(this.$el, "")
        .getPropertyValue("height")
        .replace("px", "");

      return parseInt(height, 10);
    },
    closeGreetings() {
      const messages = new PostMessages("closeGreetings");
      messages.send();
    },
    showOrdering() {
      const messages = new PostMessages("showOrderSystem");
      messages.send();
    }
  }
};
</script>

<style lang="scss" scoped>
.bubble-greetings {
  background-color: #ffffff;
  margin: 0.2rem;
  padding: 1rem;
  width: 290px;
  max-width: 98%;
  font-size: 1rem;
  white-space: normal;
  border-radius: 15px 15px 0px 15px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  position: absolute;
  bottom: 2px;
  right: 0;

  animation-name: scale-up;
  animation-duration: 0.3s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;

  h1 {
    font-size: 1.2rem;
    margin: 0px 0 10px;
  }

  p {
    margin: 0px 0px 15px;
    line-height: 1.25rem;
    font-size: 0.8rem;
    font-weight: 300;
  }
}

.powered-by {
  font-size: 8px;
  position: absolute;
  right: 7px;
  bottom: 7px;

  a {
    color: #007bff;

    &:hover {
      text-decoration: underline;
    }
  }
}

.order-button {
  display: inline-block;
  text-decoration: none;
  padding: 7px 15px;
  font-size: 1rem;
  border-radius: 5px;
  color: #ffffff;
  background-color: #007bff;
}

.close-button {
  width: 70px;
  height: 70px;
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  cursor: pointer;

  svg {
    width: 10px;
    margin: 15px 15px 0 0;
  }
}

@keyframes scale-up {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
</style>
